import { BaseHttpService } from '../../http/base-http.service';
import { Observable } from 'rxjs/index';
import { Injectable } from '@angular/core';

@Injectable()
export class IndustriesDataService extends BaseHttpService {

  private urls = {
    fetchIndustries: '/industries?all=true',
  };

  fetchIndustries(): Observable<any> {
    return this.get(this.urls.fetchIndustries);
  }
}
